'use strict';

var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var SEARCH_TERM_KEY = 'fragua_search_term';

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.search-suggestions').addClass('modal');
    }
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.search-suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        toggleResetButton(this);
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.search-suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
    }
}


/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function clearSuggestionWrapper() {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    $suggestionsWrapper.hide();
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    $.ajax({
        context: scope,
        url: endpoint + encodeURIComponent($(scope).val()),
        method: 'GET',
        success: processResponse,
        error: function () {
            clearSuggestionWrapper();
        }
    });
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.search-suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

/**
 * Checks if the search input field within the given form is empty.
 * @param {jQuery} $form - The jQuery object representing the form to check.
 * @returns {boolean} Returns true if the search field is empty, otherwise false.
 */
function isEmptySearch($form) {
    var searchQuery = $form.find('.search-field').val();
    return searchQuery.length === 0;
}

/**
 * Retrieves the search term kept for the current browsing session
 * @return {string} - Stored search term, empty string when there is none or the storage is not available
 */
function getStoredSearchTerm() {
    try {
        return window.sessionStorage.getItem(SEARCH_TERM_KEY) || '';
    } catch (e) {
        return '';
    }
}

/**
 * Keeps the search term for the current browsing session
 *
 * @param {string} term - Search term to store
 */
function setStoredSearchTerm(term) {
    try {
        window.sessionStorage.setItem(SEARCH_TERM_KEY, term);
    } catch (e) {
        // Storage can be unavailable, the search results page still renders the term server side
    }
}

/**
 * Drops the search term kept for the current browsing session
 */
function clearStoredSearchTerm() {
    try {
        window.sessionStorage.removeItem(SEARCH_TERM_KEY);
    } catch (e) {
        // Storage can be unavailable, nothing to clean up in that case
    }
}

/**
 * Shows the clear button while the search field holds a term and hides it otherwise
 *
 * @param {Object} scope - Search input field DOM element
 */
function toggleResetButton(scope) {
    $(scope).siblings('.reset-button').toggleClass('d-sm-block', $(scope).val().length > 0);
}

/**
 * Applies the search term persistence for the page the search bar is rendered on. The search
 * results page paints the term server side and feeds the session with it, the product detail page
 * is page cached so it restores the term from the session, and any other page drops it.
 *
 * @param {Object} scope - Search input field DOM element
 */
function applySearchTermPersistence(scope) {
    var context = $(scope).closest('.site-search').data('search-context');

    if (context === 'srp') {
        setStoredSearchTerm($(scope).val());
    } else if (context === 'pdp') {
        $(scope).val(getStoredSearchTerm());
    } else {
        clearStoredSearchTerm();
    }

    toggleResetButton(scope);
}

module.exports = function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        if (isEmptySearch($(this))) {
            e.preventDefault();
        }

        var suggestionsList = $('.search-suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        /**
         * The suggestions panel must never open on its own when the term is restored, so a focus
         * only opens it when it comes right after the shopper reached for the field.
         */
        var userInitiated = false;

        applySearchTermPersistence(this);

        $(this).on('mousedown touchstart keydown', function () {
            userInitiated = true;
        });

        $(this).on('blur', function () {
            userInitiated = false;
        });

        $(this).on('input', function () {
            toggleResetButton(this);
        });

        $(this).on('keyup focus', function (e) {
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    if (e.type === "focus" && !userInitiated) {
                        break;
                    }

                    const regex = /^([A-Za-z0-9]|Delete|Backspace|Enter)$/;
                    const key = e.key;

                    // Check if the key matches the regex
                    if (regex.test(key) || e.type === "focus") {
                        debounceSuggestions(this, e);
                    }
            }
        });
    });

    $('body').on('click', function (e) {
        if (!$('.search-suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
            $('.search-suggestions').hide();
        }
    });

    $('.site-search .reset-button').on('click', function () {
        var $searchField = $(this).siblings('input.search-field');

        $searchField.val('');
        clearStoredSearchTerm();
        toggleResetButton($searchField);
    });
};
